import Globals from './Globals.js';
import rpAPI from '../service/rpAPI.js';


class Location {
    static fields = [
    'id',
    'name',
    'address',
    'city',
  ];

    constructor(data) {
      Object.assign(this, data);
    }

    fullAddress() {
        return (this.city + ", " + this.address) || "Nieznana lokalizacja";
    }
}

export default Location;